/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from "axios";
import { IAddressEntity, IAddressSearchResponse, ICreateAddressPayload } from "./addresses.interface";
import { Result } from "../../../Shared/Protocol/protocol-result";

export class AddressesApiRemoteService {
  constructor(private service: AxiosInstance) {}

    public search = async (zipCode: string): Promise<Result<IAddressSearchResponse>> => {
    try {
        const response = await this.service.get(`/addresses/find-by-zipcode`, {
            params: {
                zipcode: zipCode
            }
        });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public destroy = async (addressId: string): Promise<Result<void>> => {
    try {
        const response = await this.service.delete(`/addresses/${addressId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public create = async (data: ICreateAddressPayload): Promise<Result<void>> => {
    try {
        const response = await this.service.post(`/addresses`, data );

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

//   public list = async ({ page, searchBy, personType}: IListAddressesPayload): Promise<Result<ICustomerListResponse>> => {
//     try {
//         const response = await this.service.get(`/customers`, { params: { 
//           offset: 50,
//           page,
//           searchBy,
//           personType
//         }});

//       return Result.ok(response.data);
//     } catch (error: any) {
//       return Result.fail(error?.response?.data ?? error);
//     }
//   };

  public show = async (addressId: string): Promise<Result<IAddressEntity>> => {
    try {
        const response = await this.service.get(`/addresses/${addressId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public update = async (data: IAddressEntity): Promise<Result<void>> => {
    try {
        const response = await this.service.put(`/addresses/${data.id}`, data );

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };
}
